import { Button, Typography, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { postBotMessage } from '../http/clinicAPI';
import Editor from './Editor';
import useSnackbar from '../hooks/useSnackbar';
import { changeForDB, changeForEditor, getPlainTextLength } from '../helpers/editorFunc';
import MySnackbar from './MySnackbar';

const BotMessage = React.memo(({ botMessage, type, description }) => {
  const snack = useSnackbar(false, 'Ошибка');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (botMessage) {
      setMessage(changeForEditor(botMessage.message));
    }
  }, [botMessage]);

  const save = async () => {
    try {
      const data = await postBotMessage({
        message: changeForDB(message),
        type,
        id: botMessage?.id,
      });
      if (data.error) throw new Error(data.error);
      snack.handleChange(true, 'Сохранено', 'success');
    } catch (error) {
      snack.handleChange(true, error.message, 'error');
    }
  };

  const handleEditorChange = (value) => {
    const plainTextLength = getPlainTextLength(value);
    if (plainTextLength > 800) {
      snack.handleChange(true, 'Количество символов до 800');
      return;
    }
    setMessage(value);
  };

  return (
    <Box
      sx={{
        my: 3,
        p: 2,
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        boxShadow: '0px 2px 15px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Typography variant='h5' sx={{mb:1}}>{description}</Typography>

      <Editor value={message} setValue={handleEditorChange} />
      <Button variant='outlined' disabled={!message} onClick={save}>
        Сохранить шаблон сообщения
      </Button>
      <MySnackbar {...snack} />
    </Box>
  );
});

export default BotMessage;
